import type { SubtitleSlot, SubtitleStore } from '../state/subtitleStore.ts';

export function slotHasTranslationLang(
  settings: { mainTranslations: string[]; secondTranslations: string[] },
  slot: SubtitleSlot,
): boolean {
  const list = slot === 'main' ? settings.mainTranslations : settings.secondTranslations;
  const code = list[0];
  return Boolean(code && code !== 'null');
}

/** Extension dualMain / dualSecond: flip dualMode when a translation lang is set. */
export function toggleDualMode(
  store: SubtitleStore,
  slot: SubtitleSlot,
  hasTranslationLang: boolean,
): boolean {
  if (!hasTranslationLang) {
    store.setViewState(slot, { dualMode: false });
    return false;
  }
  const next = !store.getSlot(slot).view.dualMode;
  store.setViewState(slot, { dualMode: next, hidden: false });
  return next;
}
